import { Editor as DraftJSEditor } from 'draft-js'
import { ComponentProps, FC, useContext } from 'react'
import { EditorContext } from '../EditorContext'
import { Root } from '../primatives'

export interface Props {
  lineClamp?: number
}

export const EditorReadOnly: FC<Props & ComponentProps<typeof Root.ReadOnly>> = (props) => {
  const { editorState } = useContext(EditorContext)

  return (
    <Root.ReadOnly {...props}>
      <DraftJSEditor editorState={editorState} onChange={() => null} readOnly />
    </Root.ReadOnly>
  )
}
